const SDK_VERSION = "11.7.0" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
